













import Vue from 'vue';
import { translate } from '@/filters';

export default Vue.extend({
  name: 'WarehouseStockBackorder',
  props: {
    quantity: {
      type: Number,
      required: true
    },
    deliveryEstimate: {
      type: String,
      required: true
    },
    warehouseCountryFlag: {
      type: String,
      required: true
    }
  },
  computed: {}
});
